import styled from "styled-components";

import { contentStyles } from "../../utils/styles";

export const ContentStyles = styled.span`
  /** 0. Pretend we're not here **/
  display: contents;

  /* ck-editor is clobbering our custom styles with. restating with greater
  specificity to solve this. */
  .ck-content {
    ${contentStyles}
  }

  ${contentStyles}
`;
